import { AdacButton, AdacButtonProps } from '@adac-de/component-library';
import React, { forwardRef } from 'react';
import { withTracking } from '@utils/tracking/tracking';

export type ButtonProps = {
  variant?: AdacButtonProps<'button'>['variant'];
} & React.PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement>>;

const PolymorphicButton = forwardRef(
  ({ children, ...rest }: ButtonProps, ref: React.Ref<HTMLButtonElement>) => (
    <AdacButton ref={ref} {...rest}>
      {children}
    </AdacButton>
  )
);

export const Button = withTracking(PolymorphicButton);
